import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import Cookies from 'js-cookie';

// components
import { Card, CardBody, Row, Col, Container, FormGroup, Form, Input, Button } from "reactstrap";
import { showMessage } from "services/message.js";

// services
import { api_POST } from "services/api_service.js";

//Context
import { useAuth } from "../../context/auth";

export default function Login({ history }) {

    const { register, handleSubmit } = useForm({ mode: "onBlur" });

    const { signIn, signOut, setLoading, setupSistema } = useAuth()

    useEffect(() => {
        signOut(false, null);
    }, []);

    const onSubmit = (data) => {
        if (data.login == "" || data.senha == "") {
            showMessage("Aviso", "Informe o login e senha!", 'warning', null);
            return;
        }

        let jsonSubmit = {
            login: data.login,
            password: data.senha
        }

        setLoading(true);
        api_POST(`Authenticate/AutenticarUsuarioInterno/`, jsonSubmit)
            .then(result => {
                if (result.data == null) {
                    showMessage("Aviso", "Usuário/Senha não encontrado", 'warning', null);
                }
                else {
                    Cookies.remove("filtroModalidade");
                    signIn(result.data);
                    history.push("/admin/inicio");
                }
            })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }
    return (
        <>
            <div className="content" style={{ marginTop: "50px" }}>
                <div className="border-login">
                    <Card className="card-login">
                        <CardBody>
                            <Container className="text-center">
                                <h3 className="titulo-solicitacao">BEM VINDO</h3>
                            </Container>
                            <Container style={{ marginTop: "30px" }}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Row>
                                        <Col lg="6" md="12">
                                            <div className="text-center">
                                                <h4 className="title" style={{ margin: "0px" }}>Gestão de Cadastro - {setupSistema && setupSistema.identificacao}</h4>
                                                <img src={require("assets/img/mascote.png")} />
                                            </div>
                                        </Col>
                                        <Col lg="6" md="12">
                                            <Row>
                                                <Col md="12">
                                                    <div className="formPrincipal">
                                                        <Form>
                                                            <Row>
                                                                <Col md="12" lg="12">
                                                                    <FormGroup>
                                                                        <b><label>Login</label></b>
                                                                        <Input type="login" name="login" maxLength="200" innerRef={register()} />
                                                                    </FormGroup>
                                                                    <FormGroup>
                                                                        <b><label>Senha</label></b>
                                                                        <Input type="password" name="senha" maxLength="100" innerRef={register()} />
                                                                    </FormGroup>
                                                                    <a style={{ cursor: "pointer" }} onClick={() => { history.push("/auth/esqueceusenha"); }}>Esqueci a senha</a>
                                                                </Col>
                                                            </Row>
                                                        </Form>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="text-right">
                                                <Button color="success" className="btn-mobile" type="submit">ENTRAR  <i className="fas fa-check"></i></Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </form>
                            </Container>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </>
    );
}